import { containPopupFocus } from '../../utils/popupKeyboard';

export function configureSettingsModalAccessibility(modal, owner) {
  const original = modal.initContent;
  const initContent = function (...args) {
    const opener = document.activeElement;
    const result = original.apply(this, args);
    if (!this.isOpen() || this.isDisposed()) return result;
    const content = this.getPrivate('content');
    const wrapper = this.getPrivate('wrapper');
    content.setAttribute('role', 'dialog');
    content.setAttribute('aria-modal', 'true');
    content.setAttribute('aria-label', content.querySelector('h1')?.textContent || 'Chart settings');
    owner.add(containPopupFocus(content, { opener, onDismiss: () => this.cancel() }));
    const outside = event => { if (event.target === wrapper) this.cancel(); };
    wrapper.addEventListener('click', outside);
    owner.add({ dispose: () => wrapper.removeEventListener('click', outside) });
    return result;
  };
  modal.initContent = initContent;
  modal.addDisposer({ dispose() { if (modal.initContent === initContent) modal.initContent = original; } });
}
